/**
 * String utility functions
 */
export default {
    /**
     * Capitalizes a first letter of the string.
     * @param {String} str
     * @returns {string}
     */
    capitalizeFirstLetter: function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    },

    /**
     * Sets the first letter of the string to lowercase
     * @param {String} str
     * @returns {string}
     */
    lowercaseFirstLetter: function lowercaseFirstLetter(str) {
        return str.charAt(0).toLowerCase() + str.substring(1);
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-js/StringUtil.js
// module id = 84
// module chunks = 0